enum ERoute {
  PATH_ROOT = '/:newsCenterId?/:locale',
  PATH_NEWS = '/:newsCenterId?/:locale/news/:id-:slug',
}

export default ERoute 